//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Chart from '../../general/Chart';
export default {
  name: 'SmokingChart',
  components: {
    Chart: Chart
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    setDefinitions: function setDefinitions() {
      return [{
        title: t('health', 'Cigarettes', {}),
        columnId: 'cigarettes',
        timeId: 'date',
        valueId: 'cigarettes',
        getValueY: function getValueY(v) {
          return v;
        },
        borderColor: 'darkblue',
        borderWidth: 2,
        fill: true,
        show: this.person.smokingColumnCigarettes
      }, {
        title: t('health', 'Desire level', {}),
        columnId: 'desireLevel',
        timeId: 'date',
        valueId: 'desireLevel',
        getValueY: function getValueY(v) {
          var maxIndex = 6;
          return Math.round((v + 1) / (maxIndex + 1) * 10);
        },
        borderColor: 'darkred',
        borderWidth: 2,
        fill: false,
        show: this.person.smokingColumnDesireLevel
      }, {
        title: t('health', 'Saved money', {}),
        columnId: 'savedMoney',
        timeId: 'date',
        valueId: 'calculate',
        getValueY: function getValueY(v) {
          if (!this.calcData.price || !this.calcData.start || v.cigarettes >= this.calcData.start) {
            return null;
          } else {
            var count = this.calcData.start - v.cigarettes;
            return Math.round(count * this.calcData.price * 100) / 100;
          }
        },
        calcData: {
          price: this.person.smokingPrice,
          currency: this.person.currency,
          start: this.person.smokingStartValue
        },
        borderColor: 'green',
        borderWidth: 1,
        fill: true,
        type: 'bar',
        show: this.person.smokingColumnSavedMoney
      }, {
        title: t('health', 'Goal', {}),
        columnId: 'goal',
        timeId: 'date',
        valueId: 'static',
        getValueY: this.person.smokingGoal,
        borderColor: 'darkgreen',
        borderWidth: 2,
        borderDash: [8, 5],
        fill: false,
        show: !!this.person.smokingGoal
      }, {
        title: t('health', 'Initial cigarettes', {}),
        columnId: 'startValue',
        timeId: 'date',
        valueId: 'static',
        getValueY: this.person.smokingStartValue,
        borderColor: 'darkred',
        borderWidth: 2,
        borderDash: [2, 5],
        fill: false,
        show: !!this.person.smokingStartValue
      }];
    },
    options: function options() {
      return {
        title: {
          text: t('health', 'Chart')
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              minUnit: 'day'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'gray',
              z: 100,
              lineWidth: 1
            },
            scaleLabel: {
              display: true,
              labelString: t('health', 'Values')
            },
            min: 0,
            max: 100
          }]
        },
        tooltips: {
          enabled: true
        },
        layout: {
          padding: {
            right: 30,
            left: 25
          }
        },
        legend: {
          position: 'bottom'
        }
      };
    },
    chartStyle: function chartStyle() {
      return {
        height: '250px'
      };
    }
  }
};